export function detectTable(text) {
    return /^<table[\s\S]*<\/table>/.test(text);
}
//# sourceMappingURL=detectTable.js.map